// ECONOMIK: direct-to-checkout CTA for the pago-inmediato product template.
// The COD/default template does not load this module.
const selector = '[data-ek-prepaid-buy-now]';

function syncButton(button) {
  const form = button.closest('form');
  const nativeButton = form?.querySelector('[data-testid="standalone-add-to-cart"]');
  const variant = form?.querySelector('input[name="id"]')?.value;
  const disabled = !form || !nativeButton || nativeButton.disabled || !/^\d+$/.test(variant || '');
  if (button.disabled !== disabled) button.disabled = disabled;
}

function attachButton(button) {
  if (button.dataset.ekBound === 'true') return;
  const form = button.closest('form');
  if (!form) return;
  button.dataset.ekBound = 'true';
  const observer = new MutationObserver(() => syncButton(button));
  observer.observe(form, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true });
  syncButton(button);
}

function init() {
  document.querySelectorAll(selector).forEach(attachButton);
}

document.addEventListener('click', (event) => {
  const button = event.target.closest?.(selector);
  if (!button || button.disabled) return;
  const form = button.closest('form');
  const error = form?.querySelector('.ek-prepaid-buy-now-error');
  const showError = (message) => {
    if (error) {
      error.textContent = message;
      error.hidden = false;
    }
  };

  if (!form || !form.reportValidity()) return;
  if (error) error.hidden = true;

  const nativeButton = form.querySelector('[data-testid="standalone-add-to-cart"]');
  if (!nativeButton || nativeButton.disabled) {
    showError('Selecciona una variante disponible.');
    return;
  }

  const variantId = form.querySelector('input[name="id"]')?.value?.trim() || '';
  const quantitySelector = form.querySelector('quantity-selector-component');
  const quantityInput = form.querySelector('quantity-selector-component input[ref="quantityInput"], input[name="quantity"]');
  const amount = typeof quantitySelector?.getValue === 'function'
    ? Number(quantitySelector.getValue())
    : Number(quantityInput?.value || 1);
  const minimum = Number(quantityInput?.min || 1);
  const maximum = quantityInput?.max ? Number(quantityInput.max) : null;
  const increment = Number(quantityInput?.step || 1);

  if (!/^\d+$/.test(variantId) || !Number.isSafeInteger(amount) || amount < minimum ||
      (maximum !== null && amount > maximum) ||
      (Number.isFinite(increment) && increment > 0 && (amount - minimum) % increment !== 0)) {
    showError('Revisa la variante y la cantidad seleccionadas antes de comprar.');
    return;
  }

  // Cart permalinks go directly to Shopify checkout with just this item.
  // They avoid the existing cart and preserve the separate Releasit COD route.
  const base = button.dataset.cartBase || '';
  if (!/^\/[a-zA-Z0-9_\/-]*cart\/$/.test(base)) {
    showError('No fue posible abrir el pago. Intenta nuevamente.');
    return;
  }

  button.disabled = true;
  button.textContent = 'Redirigiendo al pago…';
  window.location.assign(base + variantId + ':' + amount);
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
